export default "__VITE_ASSET__DgmNOFAO__"